import Crud from '@/views/AbsenceRequest/Crud'
import Add from '@/views/AbsenceRequest/Add'
import Approve from '@/views/AbsenceRequest/Approve'

const routes = {
  path: '/absenceRequests',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/absenceRequests',
      name: 'Listagem de ausencia',
      component: Crud,
    },
    {
      path: '/absenceRequest/:id?',
      name: 'Solicitações de ausencia',
      component: Add,
    },
    {
      path: '/absenceRequests/approve',
      name: 'Aprovacao de Solicitacao de ausencia',
      component: Approve,
    },
  ],
}

export default routes
